import React, { useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { usePainelPublico } from "../../../hooks/usePainelPublico";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import MapaGoogle from "../../../components/MapaGoogle";
import { actionGetDashboardGeralPublico } from "../../../features/(ApiKey)/Mapa/get/slices";
import "./style.scss";
import { actionGetAlertasProperty } from "../../../features/alertas/getAll-alertas/slices";
import { actionGetAlertasAbertosPublico } from "../../../features/(ApiKey)/alertas/get/slices";
import { LoaderCircleIcon } from "lucide-react";

const PageMapaAlertas = () => {
  const dispatch = useAppDispatch();
  const { apiKey, status, data: painelData } = usePainelPublico();
  const dashboard = useAppSelector((state) => state.getDashboardGeralPublico);
  const { data: metrics } = useAppSelector((state) => state.getAlertasProperty);

  const alertasAbertosState = useAppSelector(
    (state) => state.getAlertasAbertosPublico,
  );
  const listaAlertasObjetos = alertasAbertosState?.data || [];

  console.log("DashboardGeral (API Key)", dashboard);
  console.log("Metrics Property:", metrics);
  console.log("Alertas Abertos (API Key)", listaAlertasObjetos);

  const logos = painelData?.logos || [];
  const idCliente = painelData?.idCliente as number;

  const contagemAlertasFiltrados = useMemo(() => {
    const listaAlertasRaw = dashboard.data?.lastAlertas;
    const totais = { criticos: 0, atencao: 0, informativos: 0 };

    if (!listaAlertasRaw || !Array.isArray(listaAlertasRaw)) return totais;

    listaAlertasRaw.forEach((alertaTexto: string) => {
      const textoUpper = alertaTexto.toUpperCase();
      if (
        textoUpper.includes("INCÊNDIO") ||
        textoUpper.includes("FALHA") ||
        textoUpper.includes("FUMAÇA") ||
        textoUpper.includes("EMERGÊNCIA") ||
        textoUpper.includes("DESARMADO") ||
        textoUpper.includes("ATUADO")
      ) {
        totais.criticos += 1;
      } else if (
        textoUpper.includes("MANUAL") ||
        textoUpper.includes("ABAIXO DO LIMITE") ||
        textoUpper.includes("PRESSÃO") ||
        textoUpper.includes("NÍVEL") ||
        textoUpper.includes("KGF/CM2") ||
        textoUpper.includes("BAR")
      ) {
        totais.atencao += 1;
      } else {
        totais.informativos += 1;
      }
    });
    return totais;
  }, [dashboard.data?.lastAlertas]);

  const localizacoesCriticasAgrupadas = useMemo(() => {
    if (!Array.isArray(listaAlertasObjetos) || listaAlertasObjetos.length === 0)
      return [];

    const agrupamento: {
      [key: number]: {
        unidade: string;
        titulo: string;
        quantidade: number;
        tempoRelativo: string;
      };
    } = {};

    const calcularTempoRelativo = (dataString: string) => {
      try {
        const agora = new Date();
        const evento = new Date(dataString);
        const diferencaMs = agora.getTime() - evento.getTime();
        const diferencaMinutos = Math.floor(diferencaMs / (1000 * 60));

        if (diferencaMinutos <= 0) return "agora mesmo";
        if (diferencaMinutos < 60) return `há ${diferencaMinutos} min`;

        const horas = Math.floor(diferencaMinutos / 60);
        if (horas < 24) return `há ${horas}h`;

        return `há ${Math.floor(horas / 24)} dias`;
      } catch {
        return "recente";
      }
    };

    listaAlertasObjetos.forEach((item: any) => {
      const textoUpper = (item.descricao || "").toUpperCase();

      if (
        textoUpper.includes("ENCONTRA-SE OFFLINE") ||
        textoUpper.includes("OFFLINE")
      ) {
        return;
      }

      const idLoja = item.idLoja;
      const nomeLoja = item.loja?.nome || "Unidade Desconhecida";
      const numeroLoja = item.loja?.numero || "0";
      const ufLoja = item.loja?.uf || "";

      const labelUnidade = `UNIDADE ${ufLoja} — Loja ${numeroLoja} (${nomeLoja})`;

      if (!agrupamento[idLoja]) {
        agrupamento[idLoja] = {
          unidade: labelUnidade,
          titulo: item.descricao,
          quantidade: 0,
          tempoRelativo: calcularTempoRelativo(item.dataEvento),
        };
      }

      agrupamento[idLoja].quantidade += 1;
    });

    return Object.values(agrupamento);
  }, [listaAlertasObjetos]);

  const statusBrasil = useMemo(() => {
    return (
      dashboard.data?.mapaBrasil?.reduce((acc: any, item: any) => {
        return { ...acc, [item.sigla.toLowerCase()]: item.status };
      }, {}) || {}
    );
  }, [dashboard.data]);

  useEffect(() => {
    if (status !== "ready" || !apiKey) return;

    const fetchDadosDashboard = () => {
      dispatch(actionGetDashboardGeralPublico(apiKey));
      dispatch(
        actionGetAlertasAbertosPublico({ idLoja: 0, idCliente: 1, apiKey }),
      );

      if (idCliente !== undefined && idCliente !== null) {
        dispatch(
          actionGetAlertasProperty({
            idLoja: 0,
            idCliente: idCliente,
            apiKey: apiKey,
          }),
        );
      }
    };

    fetchDadosDashboard();

    const interval = setInterval(fetchDadosDashboard, 60000);
    return () => clearInterval(interval);
  }, [status, apiKey, idCliente, dispatch]);

  if (status === "loading" || dashboard.status === "loading") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <LoaderCircleIcon className="loader" />
      </div>
    );
  }

  return (
    <div className="pma-root">
      <aside className="pma-aside pma-aside--left">
        <h2 className="pma-aside__title">Alertas (24h)</h2>
        <div>
          {logos.length > 0 &&
            ReactDOM.createPortal(
              <div className="logos">
                {logos.map((logoUrl: string, i: number) => (
                  <img
                    className="logo"
                    key={i}
                    src={logoUrl}
                    alt={`Logo ${i + 1}`}
                  />
                ))}
              </div>,
              document.body,
            )}
        </div>
        <div className="pma-alert-list">
          <div className="pma-alert-item pma-alert-item--critico">
            <span className="pma-alert-dot" />
            <span className="pma-alert-label">Críticos</span>
            <span className="pma-alert-count">
              {contagemAlertasFiltrados.criticos}
            </span>
          </div>
          <div className="pma-alert-item pma-alert-item--atencao">
            <span className="pma-alert-dot" />
            <span className="pma-alert-label">Atenção</span>
            <span className="pma-alert-count">
              {contagemAlertasFiltrados.atencao}
            </span>
          </div>
          <div className="pma-alert-item pma-alert-item--informativo">
            <span className="pma-alert-dot" />
            <span className="pma-alert-label">Informativos</span>
            <span className="pma-alert-count">
              {contagemAlertasFiltrados.informativos}
            </span>
          </div>
        </div>

        <div className="pma-stat-card">
          <span className="pma-stat-card__label">Ocorrências Tratadas</span>
          <span className="pma-stat-card__sublabel">Últimos 30 dias</span>
          <span className="pma-stat-card__value">
            {metrics?.tratadas30d
              ? metrics.tratadas30d.toLocaleString("pt-BR")
              : "0"}
          </span>
        </div>

        <div className="pma-stat-card">
          <span className="pma-stat-card__label">
            Importância Segurada (R$)
          </span>
          <span className="pma-stat-card__sublabel">Total ano (aprox.)</span>
          <span className="pma-stat-card__value pma-stat-card__value--md">
            R${" "}
            {metrics?.importanciaSegurada
              ? metrics.importanciaSegurada.toLocaleString("pt-BR")
              : "0,00"}
          </span>
        </div>
      </aside>

      <section className="pma-map-section">
        <h2 className="pma-section-title">Mapa de Localidades Monitoradas</h2>
        <div className="pma-map-wrapper">
          <MapaGoogle
            fillScreen={false}
            status={statusBrasil}
            lojasMapa={dashboard.data?.lojasMapa || []}
            agrupar
            agruparPor="UF"
            zoom={5}
          />
        </div>
      </section>

      <aside className="pma-aside pma-aside--right">
        <h2 className="pma-aside__title">Críticos por Localidade</h2>

        <div className="pma-critico-list">
          {localizacoesCriticasAgrupadas.length === 0 ? (
            <div className="pma-empty-alert">Nenhum alerta crítico ativo.</div>
          ) : (
            localizacoesCriticasAgrupadas.map((card, i) => (
              <div key={i} className="pma-critico-card">
                <div className="pma-critico-card__header">
                  <span className="pma-critico-card__unidade">
                    {card.unidade}
                  </span>
                  <span className="pma-critico-card__badge">
                    {card.quantidade}
                  </span>
                </div>
                <p className="pma-critico-card__titulo">{card.titulo}</p>
                <span className="pma-critico-card__meta">
                  {card.tempoRelativo} · SLA T+1h
                </span>
              </div>
            ))
          )}
        </div>
      </aside>
    </div>
  );
};

export default PageMapaAlertas;
